import React from 'react';
import { Slide } from '@material-ui/core';
import Routes from 'routes';
import { registerFromInvitationSuccessStep as registerLocales } from 'globals/locales/registration';
import FsAlertBoard from 'ui-elements/alerts/FsAlertBoard';
import { FsStep } from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import { ReactComponent as SuccessIcon } from 'assets/images/invite-new-user/invite-new-user-success.svg';

const RegisterFromInvitationSuccessStep: React.FC = () => {
  return (
    <Slide direction="left" in timeout={300}>
      <FsStep>
        <FsAlertBoard
          title={registerLocales.title}
          maxWidth={440}
          icon={<SuccessIcon />}
          buttonLabel={registerLocales.buttonLabel}
          url={Routes.LOGIN}
        >
          {registerLocales.description}
        </FsAlertBoard>
      </FsStep>
    </Slide>
  );
};

export default RegisterFromInvitationSuccessStep;
